import { render, staticRenderFns } from "./zoomimg.vue?vue&type=template&id=5777396e&scoped=true&"
import script from "./zoomimg.vue?vue&type=script&lang=js&"
export * from "./zoomimg.vue?vue&type=script&lang=js&"
import style0 from "./zoomimg.vue?vue&type=style&index=0&id=5777396e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777396e",
  null
  
)

export default component.exports